import { useEffect, useState } from "react";
import { InputProps } from "react-admin";
import { Dialog } from "./Dialog";
import { useQueryParams } from "../../../../common/hooks/useQueryParams";
import { fullDate } from "./utils";
import { utcToZonedTime } from "date-fns-tz";

export interface DateTimePickerProps extends InputProps {
  value: Date | null;
  timeZone?: string | null;
}

export const DateTimePicker = ({
  value,
  timeZone,
  TextFieldComponent,
  inputVariant: variant,
  cancelLabel,
  okLabel,
  onChange,
  ...props
}: DateTimePickerProps) => {
  const [open, setOpen] = useState(false);
  const params = useQueryParams();

  useEffect(() => {
    if (value || !onChange) return;
    const sourceParams = params.get("source");
    if (!sourceParams) {
      onChange(new Date());
      return;
    }
    const {
      date: dateString,
      homeTerminalTimeZone: queryTimeZone,
    } = JSON.parse(sourceParams);
    let date = dateString ? new Date(dateString) : new Date();
    if (date.toDateString() !== new Date().toDateString()) {
      date.setHours(0, 0, 0, 0);
    } else {
      date = new Date();
    }
    onChange(utcToZonedTime(date, timeZone || queryTimeZone));
  }, [value, onChange, params, timeZone]);

  const clickHandler = (e: any) => {
    if (props.disabled) return;
    ((e.target as unknown) as HTMLInputElement).blur();
    setOpen(true);
  };

  const closeHandler = () => setOpen(false);
  const submitHandler = (data: any) => {
    if (!onChange) return;
    onChange(data);
    closeHandler();
  };

  return (
    <>
      <TextFieldComponent
        {...props}
        variant={variant}
        value={fullDate(value as Date)}
        onClick={clickHandler}
      />
      <Dialog
        defaultValue={value as Date}
        cancelLabel={cancelLabel}
        okLabel={okLabel}
        onClose={closeHandler}
        onSubmit={submitHandler}
        open={open}
      />
    </>
  );
};

export default DateTimePicker;
